// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Accordion(theme: Theme) {
  return {
    MuiAccordion: {
      defaultProps: {
        // disableGutters: true,
        // square: true,
        // elevation: 4
      },
      styleOverrides: {
        root: {
          overflow: 'hidden',
          '&::before': {
            display: 'none'
          }
          // border: `1px solid ${theme.palette.secondary.light}`,
          // '&:not(:last-child)': {
          //   borderBottom: 0
          // },
          // '&:before': {
          //   display: 'none'
          // },
          // '&.Mui-disabled': {
          //   backgroundColor: theme.palette.secondary.lighter
          // }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          borderTopColor: 'transparent !important',
        }
      }
    }
  };
}
